var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { eager: "", "max-width": "280" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "primary white--text" },
            [
              _vm._v("Link di invito\n      "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { depressed: "", icon: "" },
                  on: {
                    click: function ($event) {
                      return _vm.dismiss()
                    },
                  },
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("v-divider"),
          _vm._v(" "),
          _c("div", { staticClass: "pa-5" }, [
            _vm._v("\n      Copia il link qui sotto e "),
            _c("b", [_vm._v("condividilo con gli amici")]),
            _vm._v(" che vuoi far\n      partecipare a quest'asta\n    "),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "px-5 pb-5" }, [
            _c("div", { staticClass: "link-invito" }, [
              _vm._v(_vm._s(_vm.urlInvito)),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "px-5 pb-5 text-center" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "orange white--text",
                  attrs: { depressed: "", rounded: "" },
                  on: { click: _vm.copyToClipboard },
                },
                [_vm._v("\n        COPIA LINK DI INVITO\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }